import { api } from '@/services/api';
import { useToast } from '@/hooks/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_ASSET_QUERY_KEY } from './useGetAsset';
import { GET_SUPPLEMENTAL_ASSETS_QUERY_KEY } from './useGetSupplementalAssets';

export const usePutCriticalGeometry = () => {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationKey: ['putCriticalGeometry'],
    mutationFn: ({
      tenantId,
      assetId,
      releaseUnitVector,
    }: {
      tenantId: string;
      assetId: string;
      releaseUnitVector?: [number, number, number];
    }) => api.assets.putCriticalGeometry(tenantId, assetId, { ...(releaseUnitVector ? { releaseUnitVector } : {}) }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_ASSET_QUERY_KEY], exact: false });
      queryClient.invalidateQueries({ queryKey: [GET_SUPPLEMENTAL_ASSETS_QUERY_KEY], exact: false });
      showToast({ message: 'Part analysis updated', type: 'success' });
    },
    onError: () => {
      showToast({ message: 'Failed to update part analysis', type: 'error' });
    },
  });

  return {
    putCriticalGeometry: mutate,
    putCriticalGeometryAsync: mutateAsync,
    isPending,
  };
};
